import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Patient } from '../../core/models/patient.model';
import { MedicalRecord } from '../../core/models/patient-medical-record';
import { Appointment } from '../../core/models/appointment.model';
import { EmergencyContact } from '../../core/models/emergency-contact.model';
import { PatientService } from '../../core/services/patient.service';
import { NotificationService } from '../../core/services/notification.service';
import { PatientFileSummary } from '../patient-file-summary/patient-file-summary';
import { PatientHealthHistory } from '../patient-health-history/patient-health-history';
import { PatientPersonalDetails } from '../patient-personal-details/patient-personal-details';
import { AgePipe } from '../../core/pipes/age.pipe';

@Component({
  selector: 'app-patient-details-view',
  imports: [PatientFileSummary, PatientHealthHistory, PatientPersonalDetails, DatePipe, AgePipe],
  templateUrl: './patient-details-view.html',
  styleUrl: './patient-details-view.scss',
})
export class PatientDetailsView implements OnInit {
  patient: Patient | null = null;
  healthHistory: MedicalRecord[] = [];
  emergencyContact: EmergencyContact | null = null;
  isLoading = false;

  /** Minimal appointment wrapper so PatientFileSummary can render patient health fields. */
  get patientAsAppointment(): Appointment | null {
    if (!this.patient) return null;
    return { patient: this.patient } as Appointment;
  }

  constructor(
    private patientService: PatientService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit(): void {
    this.patient = history.state['patient'];
    this.loadFullPatient();
    this.loadHealthHistory();
    this.loadEmergencyContact();
  }

  loadFullPatient(): void {
    if (!this.patient?.id) return;
    this.patientService.getPatientById(this.patient.id).subscribe({
      next: (res) => {
        this.patient = res;
      },
      error: (err) => {
        this.notificationService.error(err.error?.message);
      },
    });
  }

  loadEmergencyContact(): void {
    if (!this.patient?.id) return;
    this.patientService.getEmergencyContactByPatientId(this.patient.id).subscribe({
      next: (res) => {
        this.emergencyContact = res;
      },
      error: (err) => {
        this.notificationService.error(err.error?.message);
      },
    });
  }

  loadHealthHistory(): void {
    if (!this.patient?.id) return;
    this.isLoading = true;
    this.patientService.getPatientMedicalRecords(this.patient.id).subscribe({
      next: (res) => {
        this.healthHistory = res;
        this.isLoading = false;
      },
      error: (err) => {
        this.isLoading = false;
        this.notificationService.error(err.error?.message);
      },
    });
  }
}
